const PREFIX = "asian_basket_paid_cart_";

function getKey(cartId) {
  return `${PREFIX}${cartId}`;
}

/* =========================================================
   MARK CART AS PAID

   Call immediately AFTER Stripe says succeeded.
   ========================================================= */

export function lockPaidCart(cartId, orderType) {
  if (typeof window === "undefined" || !cartId) {
    return;
  }

  sessionStorage.setItem(
    getKey(cartId),
    JSON.stringify({
      cart_id: cartId,
      order_type: orderType,
      payment_succeeded: true,
      awaiting_order_completion: true,
    }),
  );
}

/* =========================================================
   CHECK CART
   ========================================================= */

export function isPaidCartLocked(cartId) {
  if (typeof window === "undefined" || !cartId) {
    return false;
  }

  try {
    const value = sessionStorage.getItem(getKey(cartId));

    if (!value) {
      return false;
    }

    const parsed = JSON.parse(value);

    return Boolean(parsed?.payment_succeeded);
  } catch {
    return false;
  }
}

/* =========================================================
   REMOVE LOCK

   Only after Medusa successfully creates the order.
   ========================================================= */

export function unlockCompletedCart(cartId) {
  if (typeof window === "undefined" || !cartId) {
    return;
  }

  sessionStorage.removeItem(getKey(cartId));
}

export function hasAuthorizedPayment(cart) {
  const sessions = cart?.payment_collection?.payment_sessions || [];

  return sessions.some(
    (session) =>
      String(session?.status || "")
        .trim()
        .toLowerCase() === "authorized",
  );
}
